import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import MyBadge from '../myBadge/MyBadge';

const MyTable = (props) => {
  const { fields, data, action1, action2, action3, fieldAction, bordered } = props;
  const [actionField, setActionField] = useState(false);

  useEffect(() => {
    setActionField(fieldAction);
  }, [fieldAction]);

  return (
    <Table hover responsive bordered={bordered}>
      <thead>
        <tr>
          <th width="35">No.</th>
          {fields?.map((f) => (
            <th
              key={f.key}
              style={{ textAlign: f.isCenter ? 'center' : 'left', minWidth: '100px' }}
            >
              {f.field}
            </th>
          ))}
          {actionField && <th style={{ textAlign: 'center', minWidth: '100px' }}>Aksi</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item, idx) => (
          <tr key={item.id}>
            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{idx + 1}</td>
            {fields?.map((field) => (
              <td
                key={item.id + field.key}
                style={{ textAlign: field.isCenter ? 'center' : 'left', verticalAlign: 'middle' }}
              >
                {field.key === 'status'
                  ? (item[field.key] === 'pending' && <MyBadge color="blue">Pending</MyBadge>) ||
                    (item[field.key] === 'approved' && <MyBadge color="green">Approved</MyBadge>) ||
                    (item[field.key] === 'verified' && <MyBadge color="green">Verified</MyBadge>) ||
                    (item[field.key] === 'acknowledged' && (
                      <MyBadge color="green">Confirmed</MyBadge>
                    )) ||
                    (item[field.key] === 'rejected' && <MyBadge color="red">Rejected</MyBadge>) ||
                    (item[field.key] === 'cancelled' && (
                      <MyBadge color="purple">Cancelled</MyBadge>
                    )) ||
                    (item[field.key] === 'ignored' && <MyBadge color="yellow">Cancelled</MyBadge>)
                  : item[field.key]}
              </td>
            ))}
            {actionField && (
              <td width="200">
                <div className="d-flex gap-2 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm rounded-4"
                    onClick={() => action1(item.detail)}
                  >
                    Detail
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm rounded-4"
                    // approve by id request

                    onClick={() => {
                      const currentStatus =
                        item.actionType === 'approve'
                          ? 'approved'
                          : item.actionType === 'verify'
                          ? 'verified'
                          : 'acknowledged';
                      action2(item.detail?.id, currentStatus);
                    }}
                  >
                    {item.actionType === 'approve' && 'Approve'}
                    {item.actionType === 'verify' && 'Verifikasi'}
                    {item.actionType === 'acknowledge' && 'Diketahui'}
                  </button>
                  {item.actionType === 'approve' && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-4"
                      // reject by id request
                      onClick={() => action3(item.detail?.id, 'rejected')}
                    >
                      Reject
                    </button>
                  )}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

MyTable.propTypes = {
  data: PropTypes.array,
  action1: PropTypes.func,
  action2: PropTypes.func,
  action3: PropTypes.func,
  fields: PropTypes.array,
  fieldAction: PropTypes.bool,
  bordered: PropTypes.bool,
};

export default MyTable;
